import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {NzModalRef} from "ng-zorro-antd";

@Component({
  selector: 'app-read-more-file',
  templateUrl: './read-more-file.component.html',
  styleUrls: ['./read-more-file.component.scss']
})
export class ReadMoreFileComponent implements OnInit , AfterViewInit {
  @Input() files;
  @Input() type;
  urls: string[];
  selectedImage: string;
  constructor(private modal : NzModalRef) { }
  index = 0;
  ngOnInit() {
    console.log(this.files);
    if ( this.files.length > 0 && this.type === 'images') {
      this.urls = this.files.map(z => z.url);
    } else {
      this.urls = this.files.map(z => z.changingThisBreaksApplicationSecurity);
    }
    this.selectedImage = this.urls[0];
  }

  selectImage(index) {
    this.index = index;
    if(this.type !== 'images'){
      (document.getElementById('main-video') as HTMLImageElement).src = this.urls[this.index]

    }
    this.selectedImage = this.urls[index];
  }

  changeFocusImage(direction: string = 'next' || 'prev') {
    if (!((direction === 'prev' && this.index > 0) || (direction === 'next' && this.index < this.urls.length - 1))) {
      return;
    }

    direction === 'next' ? this.index ++ : this.index -- ;
    console.log('type', this.type);
    if (this.type === 'images') {
      document.querySelectorAll(`.small_image_list_item img`).forEach((item: HTMLElement) => {
        item.style.border = 'none';
      });
      const element =   document.getElementById(`image${this.index}`)
      element.style.border = '3px solid #00BFFF';
      const left = element.offsetLeft ;
      // const right = element.getBoundingClientRect().right;
      console.log('element', element)
      console.log('left', left)
      // console.log('right', right)
      document.getElementsByClassName('small_image_list_item')[0].scroll({left, behavior: "smooth"})
    } else {
      document.querySelectorAll(`.small_image_list_item video`).forEach((item: HTMLElement) => {
        item.style.border = 'none';
      });
      document.getElementById(`video${this.index}`).style.border = '3px solid #00BFFF';
      (document.getElementById('main-video') as HTMLImageElement).src = this.urls[this.index]
    }

    this.selectedImage = this.urls[this.index];
  }

  closeButton() {
    console.log(this.index)
    if (this.urls.length === 1) { this.deletePopUp(); }
    if (this.index === this.urls.length - 1) {
      this.index --
      this.selectedImage = this.urls[this.index];
      this.urls.splice(this.index + 1, 1);

    } else {
      this.selectedImage = this.urls[this.index + 1];

      this.urls.splice(this.index, 1);

    }
    if(this.type !== 'images') {
      (document.getElementById('main-video') as HTMLImageElement).src =   this.selectedImage
    }

  }
  deletePopUp(){
    this.modal.close();
  }

  async download(){
    const image = await fetch(this.selectedImage)
    const imageBlog = await image.blob()
    const imageURL = URL.createObjectURL(imageBlog)

    const link = document.createElement('a');
    link.href = imageURL;
    link.download = `${Math.random() * 10000}.png`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.type === 'images' ? document.getElementById(`image${this.index}`).style.border = '3px solid #00BFFF' :
        document.getElementById(`video${this.index}`).style.border = '3px solid #00BFFF';

    }, 500);
    document.querySelector<HTMLElement>('.ant-modal-content').style.boxShadow = '0 0 0';

    document.querySelector<HTMLElement>('.ant-modal-content').style.background = 'transparent';
  }

}
